import { APP_ROUTES } from "../constants";
import { assetDetailPageTabsValues } from "../pages/assetdetailpage/assetdetailpage.constants";

export function getAssetDetailPageUrl(id: string): string {
  const redirectTo = assetDetailPageTabsValues.overview;

  return `${APP_ROUTES.private_routes.assets}/${id}/${redirectTo}`;
}
